export default [
    {
        path: '/reports/budgeting',
        name: 'budgeting-reports',
        meta: { title: 'Budgeting Reports', authRequired: true },
        component: () => import('../views/reports/budgeting-catalogue.vue'),
    },
    {
        path: '/reports/budgeting/:reportCode',
        name: 'budgeting-report-runner',
        meta: { title: 'Budgeting Report', authRequired: true },
        component: () => import('../views/reports/budgeting-report-runner.vue'),
    },
    {
        path: '/annual-procurement-plans/approved-annual-procurement-plans',
        name: 'Approved-Budgets',
        meta: {
            title: "Annual Budgets",
            authRequired: true,
            privileges: ['VIEW_APP_COMPLIANCE']
        },
        component: () => import("../views/annual-procurement-plans/approved-annual-procurement-plans.vue"),
    },
    {
        path: '/annual-procurement-plans/view-app',
        name: 'View-Annual-Procurement-Plan',
        meta: {
            title: "View App",
            authRequired: true,
            privileges: ['VIEW_APP_COMPLIANCE']
        },
        component: () => import("../views/annual-procurement-plans/view-app.vue"),
    },

]
